import { ThemeProvider, createTheme, ThemeProviderProps } from '@material-ui/core/styles';
import React, { FC } from 'react';

import { browserBreakpoints } from 'utils/breakpoints';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 360,
      md: browserBreakpoints.mobile + 1,
      lg: browserBreakpoints.tablet + 1,
      xl: browserBreakpoints.desktop + 1,
    },
  },
  spacing: sp => sp * 4,
});

type GridContainerThemeProviderProps = Omit<ThemeProviderProps, 'theme'>;

export const GridContainerThemeProvider: FC<GridContainerThemeProviderProps> = props => (
  <ThemeProvider theme={theme} {...props} />
);

GridContainerThemeProvider.displayName = 'GridContainerThemeProvider';
